import React, { useState } from 'react';
import { 
  AppBar, Tabs, Tab, Toolbar, Box, Link as MuiLink, 
  IconButton, Drawer, List, ListItem, ListItemText 
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const ClassNavbar = () => {
  const location = useLocation();
  const [value, setValue] = useState(location.pathname);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleChange = (event, newValue) => setValue(newValue);
  const toggleDrawer = (open) => () => setDrawerOpen(open);

  const menuItems = [
    { label: 'Home', to: '/' },
    { label: 'Classroom', to: '/classpage' },
    { label: 'People', to: '/people' },
    { label: 'Analytics', to: '/analytics'}
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <AppBar
        position="static"
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          px: { xs: 2, md: 4 },
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {/* Logo / Title */}
          <motion.div
            whileHover={{ scale: 1.1, color: '#1976d2' }}
            transition={{ type: 'spring', stiffness: 300 }}
          >
            <MuiLink
              component={Link}
              to="/"
              underline="none"
              sx={{
                fontWeight: 'bold',
                fontSize: '1.5rem',
                letterSpacing: 1.5,
                color: 'black',
                cursor: 'pointer',
              }}
            >
              Synthetica
            </MuiLink>
          </motion.div>

          {/* Hamburger Menu Icon for Small Screens */}
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <IconButton
              edge="start"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              sx={{ color: 'black' }} // IconButton color set to black
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
              sx={{
                '& .MuiDrawer-paper': {
                  bgcolor: 'black', // Drawer background color set to black
                  color: 'white', // Text color set to white
                  width: 250,
                },
              }}
            >
              <motion.div
                initial={{ x: '100%' }}
                animate={{ x: 0 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <List>
                  {menuItems.map((item, index) => (
                    <ListItem
                      button
                      key={index}
                      component={Link}
                      to={item.to}
                      onClick={toggleDrawer(false)}
                    >
                      <ListItemText primary={item.label} sx={{ color: 'white' }} />
                    </ListItem>
                  ))}
                </List>
              </motion.div>
            </Drawer>
          </Box>

          {/* Tabs for Larger Screens */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="inherit"
              indicatorColor="primary"
              centered
              TabIndicatorProps={{ style: { height: 3, backgroundColor: '#1976d2' } }}
            >
              {menuItems.map((item, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.1, color: '#000000' }}
                  transition={{ type: 'spring', stiffness: 300 }}
                >
                  <Tab
                    label={item.label}
                    component={Link}
                    to={item.to}
                    value={item.to}
                    sx={{
                      fontSize: '1rem',
                      fontWeight: 500,
                      color: 'black',
                      textTransform: 'capitalize',
                      '&.Mui-selected': { color: '#1976d2' },
                    }}
                  />
                </motion.div>
              ))}
            </Tabs>
          </Box>
        </Toolbar>
      </AppBar>
    </motion.div>
  );
};

export default ClassNavbar;
